import classNames from 'classnames';
import FlexContainer from '../FlexContainer';
import Txt from '../Txt';
import View from '../View';
import styles from './ValueBlock.module.scss';

/**
 * ValueBlock
 *
 * @return {JSX.Element}
 */
const ValueBlock = ({ className, label, value, prefix }) => {
  return (
    <FlexContainer
      className={classNames(
        styles.ValueBlock,
        className,
        `${ValueBlock.displayName}`
      )}
      gap
      column
    >
      <View>
        <Txt bold>{label}</Txt>
      </View>
      <FlexContainer justifyContentEnd alignEnd gapQuad>
        {prefix ? (
          <Txt className={styles.Prefix} bold xx>
            {prefix}
          </Txt>
        ) : null}
        <Txt bold xxxxx>
          {value}
        </Txt>
      </FlexContainer>
    </FlexContainer>
  );
};

ValueBlock.displayName = 'ValueBlock';

export default ValueBlock;
